import { ContentIntro } from './intro';

/**
 * Model definition for Product Comparison
 */
export interface ProductComparison {
  __component: 'content.product-comparison';
  id: string;
  intro?: ContentIntro;
  schema?: { [key: string]: unknown };
}

export function isProductComparison(obj: { __component?: string }): obj is ProductComparison {
  return obj.__component === 'content.product-comparison';
}
